import { Link, Outlet } from 'react-router-dom';

export const Layout = () => {
  return (
    <div className="h-screen w-screen overflow-hidden relative bg-background">
      <div className="h-screen w-screen absolute opacity-80"></div>
      <div className="w-screen h-screen z-10 absolute overflow-scroll" id="scroll-container">
        <div className="h-full flex flex-col">
          <div className="grow flex justify-center w-full max-w-6xl mx-auto">
            <main className="grow text-foreground md:p-8 p-6">
              <div>
                <Outlet />
              </div>
            </main>
          </div>
          <footer className="border-t py-2 backdrop-blur bg-white/20 text-green-100 font-bold">
            <div className="container space-x-8 text-center flex justify-center items-center text-xs">
              <Link to="/">Tickets</Link>
              <a href="https://ra.co/events/2278254">Resident Advisor</a>
              <Link to="/imprint">Imprint</Link>
              <Link to="/privacy">Privacy</Link>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
